import './ai-products.css';

export const pageTitle = 'Product Strategy';
export const pageSubmenu = 'AI';  

export const AIProducts = () => (
  <iframe
    src="product-strategy.html"
    className="ai-products-frame"
    title="AI Product Strategy"
  />
);